
import { CartItem } from "@/types/cart";

const CART_STORAGE_KEY = 'krecao_cart';

export const loadCartFromStorage = (): CartItem[] => {
  const savedCart = localStorage.getItem(CART_STORAGE_KEY);
  if (savedCart) {
    try {
      return JSON.parse(savedCart);
    } catch (e) {
      console.error("Failed to parse cart from localStorage:", e);
      // Reset cart if there's an error
      localStorage.removeItem(CART_STORAGE_KEY);
    }
  }
  return [];
};

export const saveCartToStorage = (cart: CartItem[]): void => {
  localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
};

export const clearCartFromStorage = (): void => {
  localStorage.removeItem(CART_STORAGE_KEY);
};
